import type { JSX, ParentComponent } from "solid-js";

export const MainContentContainer: ParentComponent<{
	centered?: boolean;
	style?: JSX.CSSProperties;
	class?: string;
}> = (props) => {
	return (
		<div
			class={`main-content-container ${props.class ?? ""}`}
			classList={{ centered: props.centered }}
			style={props.style}
		>
			{props.children}
		</div>
	);
};
